module.exports = __webpack_public_path__ + "f457b82fbf004444804f06c2894a6c2c.svg";